import styled from '@emotion/styled'

export const StyleImage = styled.img<any>`
  object-fit: ${(props: any) => props.fit || 'inherit'};
  border-radius: ${(props: any) => props.radius || 0}px;
  ${(props: any) => props?.styleImage}
`
